import request from '@/config/axios'
import { asCapacityPage, type CapacityPageResult } from '@/api/capacity/page'

/** 时效公里档：maxKm 空=兜底「以上」 */
export interface EtaKmRule {
  maxKm?: number | null
  minutes: number
}

export interface OpsConfig {
  platformRate?: number
  defaultOrgRate?: number
  transferFeeRate?: number
  transferFreeDaily?: number
  orgRates?: Record<string, number>
  /** 骑手单日提现限额（元） */
  dailyWithdrawLimit?: number
  /** 按取送直线公里匹配时效（分钟） */
  etaKmRules?: EtaKmRule[]
  cateringEnabled?: boolean
  failWhenDisabled?: boolean
  capacityCheckEnabled?: boolean
  minOnlineFree?: number
}

export interface OpsAudit {
  eventId: string
  actor: string
  detail?: string
  createTime?: string
}

export const getOpsConfig = () =>
  request.get<OpsConfig>({ url: '/capacity/platform/ops/config' })

export const saveOpsConfig = (data: OpsConfig) =>
  request.put<boolean>({ url: '/capacity/platform/ops/config', data })

export const listOpsAudits = async (params?: {
  pageNo?: number
  pageSize?: number
}): Promise<CapacityPageResult<OpsAudit>> => {
  const raw = await request.get({ url: '/capacity/platform/ops/audits', params })
  return asCapacityPage<OpsAudit>(raw, params?.pageNo, params?.pageSize)
}
